export const BREAK_POINTS = {
  mobile: "(min-width: 320px)",
  tablet: "(min-width: 768px)",
  desktop: "(min-width: 992px)"
};
